import { useEffect, useState } from "react";
import { getSupportMeta } from "../../helpers/kronaly_helper";

const unwrap = (r) => r?.data ?? r;

/**
 * Carga /support/meta (categorías configurables, técnicos, estados,
 * prioridades) y expone índices listos para la UI. Cada vista que necesite
 * el catálogo lo invoca; es una llamada pequeña.
 */
export function useSupportMeta() {
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getSupportMeta()
      .then((r) => {
        if (!alive) return;
        setMeta(unwrap(r));
        setError(null);
      })
      .catch((e) => {
        if (alive) setError(e?.message || String(e));
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const categoriesById = {};
  const roots = [];
  const subcategoriesByParent = {};
  (meta?.categories || []).forEach((c) => {
    categoriesById[c.id] = c;
    if (c.parent_id) {
      (subcategoriesByParent[c.parent_id] = subcategoriesByParent[c.parent_id] || []).push(c);
    } else {
      roots.push(c);
    }
  });

  const techniciansById = {};
  (meta?.technicians || []).forEach((t) => {
    techniciansById[t.membership_id] = t;
  });

  return {
    meta,
    loading,
    error,
    categoriesById,
    roots,
    subcategoriesByParent,
    techniciansById,
    technicians: meta?.technicians || [],
  };
}
